import { useHistory } from 'react-router';
import { useQueryParams } from 'Shared/util/custom-hooks';


export const useEIdCallbackQueryParams = () => {
  const history = useHistory();
  const queryParams = useQueryParams();

  const EID_CALLBACK = 'eid-callback';
  const EID_TOKEN = 'eid-token';
  const EID_PURPOSE = 'eid-purpose';
  const SCRIVE_EID_STATUS = 'success';
  const SCRIVE_EID_TRANSACTION_ID = 'transaction_id';

  const valid = () => {
    return queryParams.get(EID_CALLBACK) === 'true';
  };

  const get = () => ({
    eIdToken: queryParams.get(EID_TOKEN),
    eIdPurpose: queryParams.get(EID_PURPOSE),
    scriveEIdStatus: queryParams.get(SCRIVE_EID_STATUS),
    scriveEIdTransactionId: queryParams.get(SCRIVE_EID_TRANSACTION_ID)
  });

  const clear = () => {
    queryParams.delete(EID_CALLBACK);
    queryParams.delete(EID_TOKEN);
    queryParams.delete(EID_PURPOSE);
    queryParams.delete(SCRIVE_EID_STATUS);
    queryParams.delete(SCRIVE_EID_TRANSACTION_ID);
    history.replace({ search: queryParams.toString() });
  };

  return {
    valid,
    get,
    clear,
  };
};
